export const getPageParamFromLastPage = (lastPage) => {
  const nextUrl = lastPage.next;
  if (!nextUrl) return undefined;
  const url = new URL(nextUrl);
  const nextPageParam = url.searchParams.get('page');
  return nextPageParam ? Number(nextPageParam) : undefined;
};
